export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://tafelberg-worker.tafelberg-nuernberg.workers.dev';

const SESSION_TOKEN_KEY = 'sessionToken';
const USER_KEY = 'user';

export const getSessionToken = () => {
  try {
    return localStorage.getItem(SESSION_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const storeSession = (token, user) => {
  localStorage.setItem(SESSION_TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearSession = () => {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getApiUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;

export const apiRequest = async (endpoint, options = {}) => {
  const config = {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  };
  const token = getSessionToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const response = await fetch(getApiUrl(endpoint), config);
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  return response.json();
};
